// extracted by mini-css-extract-plugin
export default {"container":"FZ1QQMBV0trYJJmYTmQb","slideIn":"DAgjrRCHdLyZddHoNEHQ","title":"DToUpUPA1b9IYY6kil_O","description":"oMBYfjYKM1XjG1JbV1Oc","timerBar":"DosO6q0MPJMYjNZWK0ww"};